import "../css/main.css";
import { decorateH1Headlines } from "./components/h1-headline";
import { handleSearch } from "./components/search";
import { handleNavigation } from "./partials/navigation";
import { handleRoleButtons } from "./utils";
import { updateScrollOffset } from "./utils";
import { initUsercentricsReload } from "./utils/usercentrics-handler";

window.addEventListener("load", () => {
  handleRoleButtons();
  handleNavigation();
  updateScrollOffset();
  handleSearch();
  decorateH1Headlines();
  initUsercentricsReload();
});

window.addEventListener("resize", updateScrollOffset)
